export const API_URL =
  process.env.REACT_APP_API_URL || "https://api.gppa.gm/api/v1";

export const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || "https://api.gppa.gm";
